import clsx from 'clsx';
import { Link } from 'react-router';
import Icon from './Icon.jsx';
import styles from './Button.module.scss';

export default function Button({
  variant = 'default',
  size = 'md',
  icon,
  iconOnly = false,
  to,
  className,
  children,
  type = 'button',
  block = false,
  ...rest
}) {
  const cls = clsx(
    styles.btn,
    styles[variant],
    styles[size],
    iconOnly && styles.iconOnly,
    block && styles.block,
    className,
  );
  const content = (
    <>
      {icon ? <Icon name={icon} size={size === 'sm' ? 18 : 20} /> : null}
      {iconOnly ? <span className="visually-hidden">{children}</span> : children}
    </>
  );
  if (to && !rest.disabled) {
    return (
      <Link to={to} className={cls} {...rest}>
        {content}
      </Link>
    );
  }
  return (
    <button type={type} className={cls} {...rest}>
      {content}
    </button>
  );
}
